<template>
    <div class="mt-6">
         <div class="lg:max-w-1140px lg:m-auto lg:flex lg:justify-center">
            <div class="splide" id="cate-home-sub">
                <div class="splide__track">
                    <ul class="splide__list">
                        <li class="splide__slide"
                            v-for="(cate, k) in subCateList"
                            :key="k"
                            >
                            <div v-if="isActiveCate(cate)" class="bg-a-red-d62300 border border-a-red-d62300 rounded-full text-a-egg-f5ebdc px-3 py-1 cursor-pointer"
                                @click="clickCate(cate)"
                            >
                                {{getCateName(cate)}}
                            </div>
                            <div v-else
                                 class="bg-a-egg-f5ebdc border border-a-red-d62300 rounded-full text-a-red-d62300 px-3 py-1 cursor-pointer"
                                 @click="clickCate(cate)">
                                {{getCateName(cate)}}
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
//library
import Splide from '@splidejs/splide'; //https://splidejs.com/
//helper
// import Util from '@/helper/Utility.js';
//mixin
import LocaleMixin from '@/mixin/LocaleMixin';

export default {
    mixins: [LocaleMixin,],
    props: {
        mainCate: { type: Object, required: true },
        subCateList: { type: Array, required: true },
        selectedSubCat: { type: Object, default: null },
    },
    data: function () {
        return {
            slider: null,
            activeSubCateId: null,
        };
    },
    watch: {
        selectedSubCat: function () {
            this.setActiveCate();
        },
    },
    mounted: function () {
        this.setActiveCate();
        this.initSlider();
    },
    methods: {
        //#region init
        initSlider: function () {
            this.$nextTick(() => {
                let currentIndex = this.getCurrentIndex();
                this.slider = new Splide('#cate-home-sub', {
                    arrows: false,
                    pagination: false,
                    autoWidth: true,
                    gap: 12,
                    padding: 0,
                    start: currentIndex,
                    breakpoints: {
                        1024: {
                            padding: 16,
                        },
                    },
                }).mount();
                // this.slider.on('move', (newIndex) => {
                //     this.currentSliderIndex = newIndex;
                // });
            });
        },
        getCurrentIndex: function () {
            let found = 0;
            for (let i in this.subCateList) {
                if (this.subCateList[i].id == this.activeSubCateId) {
                    found = i;
                    break;
                }
            }
            return found;
        },
        //#endregion init

        //#region render
        isActiveCate: function (cate) {
            return this.activeSubCateId == cate.id;
        },
        // getClassCateName: function (cate) {
        //     if (this.isActiveCate(cate)) {
        //         return 'text-a-red-d62300';
        //     }
        //     return 'text-a-brown-502314';
        // },
        //#endregion render

        setActiveCate: function () {
            if (this.selectedSubCat != null) {
                this.activeSubCateId = this.selectedSubCat.id;
            } else {
                this.activeSubCateId = null;
            }
        },


        clickCate: function (cate) {
             this.tracking.event('homepage','click_subcategory_menu', `click_subcategory_${cate.nameEn}`, 'Under LTO');
            if (this.activeSubCateId == cate.id) {
                this.$router.replace({
                    name: 'home',
                    params: {
                        catId: this.mainCate.id,
                    }
                })
            } else {
                this.$router.replace({
                    name: 'home',
                    params: {
                        catId: this.mainCate.id,
                        subCatId: cate.id,
                    }
                })
            }

            // this.$emit('onClickCate', cate);
        },
        getCateName: function (cate) {
            return this.localeCode == 1033 ? cate.nameEn : cate.nameTh;
        },
    },
}
</script>
<style lang="scss" scoped>
</style>
